module.exports = "\n<navigation></navigation>\n\n<div class=\"app-container\">\n\n<router-outlet></router-outlet>\n\n</div>"